import React, { useState, useEffect, useRef } from 'react';
import styled from '../../styled';
import { Chevron as IconChevron } from '../icons/outline/Chevron';
import Text from '../text';
import { getTranslation } from '../../utils';
import SubTabItem from './SubTab';
import DynamicLinkTab from './DynamicLinkTab';
import SubMenu from './SubMenu';
import TabItem from './TabItem';
import TabIcon from './TabIcon';
import { MenuTextContainer, MultiLineTextContainer } from './TextContainer';
const TabIconWrapper = styled.div `
  display: flex;
  align-items: center;
  padding: 0.06rem 0.5rem 0.06rem 0;
`;
const IconWrapper = styled.div `
  display: flex;
  width: ${({ theme }) => theme.icons.size.MEDIUM};

  > svg {
    vertical-align: text-top;
    transition: transform 0.3s ease-in-out;
  }
`;
const FlexItem = styled.div `
  display: flex;
  padding: 0.63rem 0;
  align-items: center;
`;
const Tab = ({ id, e2eId, activedTabKey, expandedTabKey, lang = 'zh-hant', subs = [], icon, iconType, renderRightIcon, nameTranslations, titleTranslations, subTitleTranslations, onTabToggled = () => { }, bgColor = 'INK_800', bgActiveColor = 'INK_700', bgHoverColor = 'INK_700', hoverColor, iconHoverColor, leftBorderColor, }) => {
    const [subMenuHeight, setSubMenuHeight] = useState(0); // stores submenu original height
    const [isExpanded, setIsExpanded] = useState(false);
    const subsNum = subs.length;
    const isLastOfGroup = (index) => index === subsNum - 1 ||
        (index < subsNum - 1 && subs[index + 1].type === 'divider');
    const subMenuRef = useRef(null);
    useEffect(() => {
        if (!subMenuRef.current)
            return;
        setSubMenuHeight(subMenuRef.current.offsetHeight);
        subMenuRef.current.style.height = '0';
    }, [subMenuRef]);
    useEffect(() => {
        requestAnimationFrame(() => {
            if (!subMenuRef.current)
                return;
            subMenuRef.current.style.height = isExpanded ? `${subMenuHeight}px` : '0';
        });
    }, [isExpanded]); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        setIsExpanded(expandedTabKey ? expandedTabKey === id : false);
    }, [expandedTabKey, id]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TabItem, { "data-e2e-id": e2eId, bgColor: bgColor, bgActiveColor: bgActiveColor, bgHoverColor: bgHoverColor, hoverColor: hoverColor, iconHoverColor: iconHoverColor, isActived: activedTabKey === id ||
                subs.some(({ key: subTabKey }) => activedTabKey === subTabKey), onClick: subsNum > 0
                ? () => onTabToggled(isExpanded ? undefined : id, subMenuRef)
                : undefined },
            React.createElement(FlexItem, null,
                icon && (React.createElement(TabIconWrapper, null,
                    React.createElement(TabIcon, { icon: icon, iconType: iconType }))),
                nameTranslations ? (React.createElement(MenuTextContainer, null,
                    React.createElement(Text, { fontType: "Menu", lang: lang, color: "PRIMARY_A800" }, getTranslation(nameTranslations, lang)))) : (React.createElement(MultiLineTextContainer, null,
                    React.createElement(Text, { fontType: "Body", lang: lang, color: "INK_600", weight: "Medium" }, titleTranslations && getTranslation(titleTranslations, lang)),
                    React.createElement(Text, { fontType: "Micro", lang: lang, color: "INK_500" }, subTitleTranslations &&
                        getTranslation(subTitleTranslations, lang))))),
            renderRightIcon
                ? renderRightIcon()
                : subs.length > 0 && (React.createElement(IconWrapper, null,
                    React.createElement(IconChevron, { size: "MEDIUM", color: "INK_500", position: isExpanded ? 'TOP' : 'BOTTOM' })))),
        React.createElement(SubMenu, { ref: subMenuRef }, subs.map((subTab, index) => subTab.type === 'divider' ? (React.createElement(SubTabItem, Object.assign({ bgColor: bgColor, bgActiveColor: bgActiveColor, bgHoverColor: bgHoverColor, leftBorderColor: leftBorderColor, lang: lang, isActived: activedTabKey === subTab.key }, subTab))) : (React.createElement(DynamicLinkTab, Object.assign({ TabComponent: SubTabItem, bgColor: bgColor, bgActiveColor: bgActiveColor, bgHoverColor: bgHoverColor, hoverColor: hoverColor, iconHoverColor: iconHoverColor, leftBorderColor: leftBorderColor, lang: lang, isActived: activedTabKey === subTab.key, isLastOfGroup: isLastOfGroup(index) }, subTab)))))));
};
export default Tab;
//# sourceMappingURL=Tab.js.map